import { render, staticRenderFns } from "./partnerTip.vue?vue&type=template&id=58e498d7&scoped=true"
import script from "./partnerTip.vue?vue&type=script&lang=js"
export * from "./partnerTip.vue?vue&type=script&lang=js"
import style0 from "./partnerTip.vue?vue&type=style&index=0&id=58e498d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e498d7",
  null
  
)

export default component.exports